/**
 * useIsMaster — Rollen-Erkennung (fail-closed)
 *
 * EINE Quelle für „Bin ich der Inhaber/Master?": das Backend (`/api/account/me` →
 * `is_master`). Bewusst fail-closed: solange die Antwort aussteht ODER der Aufruf
 * fehlschlägt, gilt „kein Master". Ein Kunde darf nie versehentlich Inhaber-
 * Werkzeuge sehen; der Inhaber verliert im Fehlerfall kurz seine Zusatz-Ansicht.
 *
 * Zwei Varianten:
 *   useIsMaster()      → boolean (false, solange unbekannt) — für reines Ein-/Ausblenden.
 *   useMasterStatus()  → null | true | false — wenn „noch unbekannt" von „kein Master"
 *                        unterschieden werden muss (z. B. Routen-Guard mit Redirect:
 *                        ohne diese Unterscheidung würde der Inhaber beim Direktaufruf
 *                        umgeleitet, bevor die Antwort da ist).
 *
 * Hinweis: Die Logik ist eine bewusste Dopplung des lokalen Hooks in VideoPage.jsx —
 * diese Datei ist die wiederverwendbare Fassung für alle anderen Stellen.
 */

import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// null = Antwort steht noch aus
export function useMasterStatus() {
  const [status, setStatus] = useState(null);
  useEffect(() => {
    let active = true;
    axios.get(`${API}/account/me`)
      .then((res) => { if (active) setStatus(res.data?.is_master === true); })
      .catch(() => { if (active) setStatus(false); });
    return () => { active = false; };
  }, []);
  return status;
}

export default function useIsMaster() {
  return useMasterStatus() === true;
}
